import { render, staticRenderFns } from "./Saigai.vue?vue&type=template&id=65b716c1&scoped=true&"
import script from "./Saigai.vue?vue&type=script&lang=js&"
export * from "./Saigai.vue?vue&type=script&lang=js&"
import style0 from "./Saigai.vue?vue&type=style&index=0&id=65b716c1&scoped=true&lang=css&"
import style1 from "./Saigai.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b716c1",
  null
  
)

export default component.exports